import { render, staticRenderFns } from "./InformationBox.vue?vue&type=template&id=3baf604e&scoped=true"
import script from "./InformationBox.vue?vue&type=script&lang=ts"
export * from "./InformationBox.vue?vue&type=script&lang=ts"
import style0 from "./InformationBox.vue?vue&type=style&index=0&id=3baf604e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baf604e",
  null
  
)

export default component.exports